// eslint-disable-next-line @tseslint/no-shadow
import { ChangeDetectionStrategy, Component, contentChild, inject, model, ModelSignal, OnInit, Signal, TemplateRef, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { SideMenuTabLabel } from './directives/side-menu-tab-label.directive';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { SideMenuTabService } from './services/side-menu-tab.service';

@Component({
  selector: 'app-side-menu-tab',
  standalone: true,
  imports: [ MatButtonModule, NgTemplateOutlet, NgClass ],
  templateUrl: './side-menu-tab.component.html',
  styleUrl: './side-menu-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideMenuTabComponent implements OnInit {
  private _tabService: SideMenuTabService = inject(SideMenuTabService);

  /** Whether the tab is the selected tab or not. If multiple Tabs in a group are set to true the first one in the template to be true will be selected. */
  public isSelected: ModelSignal<boolean> = model(false);

  public isDisabled: ModelSignal<boolean> = model(false);

  protected labelTemplate: Signal<SideMenuTabLabel | undefined> = contentChild(SideMenuTabLabel);

  @ViewChild('tabContent', { "static": true })
  // eslint-disable-next-line @tseslint/no-explicit-any
  public tabContent!: TemplateRef<any>;

  public ngOnInit (): void {
    this._tabService.registerTab(this);
  }

  protected onTabClick (): void {
    this._tabService.onTabSelected(this);
  }
}
